import { useState, useEffect } from 'react';
import QUIZ_QUESTIONS from '@/quiz.json';

export default function Quiz({ onComplete }) {
  const [currentQ, setCurrentQ] = useState(0);
  const [selected, setSelected] = useState(null);
  const [score, setScore] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [animating, setAnimating] = useState(false);
  const [slideClass, setSlideClass] = useState('animate-slide-in');

  const question = QUIZ_QUESTIONS[currentQ];
  const total = QUIZ_QUESTIONS.length;

  const handleSelect = (index) => {
    if (selected !== null || animating) return;

    setSelected(index);
    const isCorrect = index === question.correct;
    const newScore = isCorrect ? score + 1 : score;
    const newAnswers = [...answers, index];

    setScore(newScore);
    setAnswers(newAnswers);

    // Wait for feedback, then advance
    setTimeout(() => {
      if (currentQ < total - 1) {
        setAnimating(true);
        setSlideClass('animate-slide-out');

        setTimeout(() => {
          setCurrentQ(currentQ + 1);
          setSelected(null);
          setAnimating(false);
          setSlideClass('animate-slide-in');
        }, 300);
      } else {
        onComplete(newScore, newAnswers);
      }
    }, 1200);
  };

  const getOptionClass = (index) => {
    if (selected === null) return 'quiz-option';
    if (index === question.correct) return 'quiz-option correct';
    if (index === selected && selected !== question.correct) return 'quiz-option wrong';
    return 'quiz-option disabled';
  };

  return (
    <div className="px-6 py-8 animate-fade-in" data-testid="quiz-screen">
      {/* Progress */}
      <div className="mb-2 flex items-center justify-between">
        <span
          className="font-subtitle text-xs"
          style={{ color: '#B5985A', letterSpacing: '0.1em', textTransform: 'uppercase' }}
          data-testid="quiz-progress-label"
        >
          Pergunta {currentQ + 1} de {total}
        </span>
      </div>

      {/* Progress Bar */}
      <div className="progress-bar mb-8" data-testid="quiz-progress-bar">
        <div
          className="progress-bar-fill"
          style={{ width: `${((currentQ + 1) / total) * 100}%` }}
        />
      </div>

      {/* Question */}
      <div className={slideClass} key={currentQ}>
        <h3
          className="font-headline text-lg mb-6 text-white leading-snug"
          data-testid="quiz-question-text"
        >
          {question.question}
        </h3>

        {/* Options */}
        <div className="space-y-3" data-testid="quiz-options">
          {question.options.map((option, i) => (
            <button
              key={i}
              className={getOptionClass(i)}
              onClick={() => handleSelect(i)}
              disabled={selected !== null}
              data-testid={`quiz-option-${i}`}
            >
              <span
                className="w-7 h-7 rounded-full flex-shrink-0 flex items-center justify-center mr-3 text-xs font-bold"
                style={{
                  background: 'rgba(181,152,90,0.12)',
                  color: '#B5985A',
                }}
              >
                {String.fromCharCode(65 + i)}
              </span>
              <span className="font-body">{option}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
